<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<iframe id="frame" :src="bookLink" scrolling="auto" @load="iFrameHeight()"
				style="width: 100%; border: 0px;margin:0;"></iframe>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		defineComponent
	} from 'vue'
	import {
		useRoute
	} from 'vue-router'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const bookLink = route.query.url;

			function iFrameHeight() {
				var ifm = document.getElementById('frame');
				if (ifm != null) {
					ifm.height = window.innerHeight - 120;
				}
			}
			console.log('111:', bookLink);
			return {
				bookLink,
				iFrameHeight
			}
		}
	})
</script>

<style>
</style>